<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmit"
        :title="$t('labels.editBankAccount')"
        :rules="rules"
        no-reset
        @close="closeOverSide">
        <hts-form-input
            v-model="formData.bankName"
            :label="$t('labels.bankName')"
            required
            name="bankName"
            prop="bankName" />

        <hts-form-input
            v-model="formData.branch"
            :label="$t('labels.branch')"
            name="branch"
            prop="branch" />

        <hts-form-input
            v-model="formData.swiftCode"
            :label="$t('labels.swiftCode')"
            name="swiftCode"
            prop="swiftCode" />

        <hts-form-input
            v-model="formData.bankAddress"
            :label="$t('labels.bankAddress')"
            name="bankAddress"
            prop="bankAddress" />

        <hts-form-input
            v-model="formData.accountNumber"
            :label="$t('labels.accountNumber')"
            required
            name="accountNumber"
            prop="accountNumber" />

        <hts-form-input
            v-model="formData.accountName"
            :label="$t('labels.accountName')"
            required
            name="accountName"
            prop="accountName" />
    </hts-drawer>
</template>
<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables'])
const id = ref('')

const formData = ref({
  accountName: '',
  bankName: '',
  branch: '',
  swiftCode: '',
  bankAddress: '',
  accountNumber: ''
})

const rules = ref({
  bankName: 'required',
  accountNumber: 'required',
  accountName: 'required'
})

const reset = () => {
  formData.value = {
    accountName: '',
    bankName: '',
    branch: '',
    swiftCode: '',
    bankAddress: '',
    accountNumber: ''
  }
}
const handleSubmit = () => {
  const api = $url.settings.editBankAccount
  $api(api, { body: formData.value, uriParams: { ID: id.value } }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.editSuccess'))
      reset()
      close()
    }
  })
}
const closeOverSide = () => {
  emits('close')
}

const close = () => {
  visible.value = false
}

const open = (idBankAccount: string) => {
  id.value = idBankAccount
  getData()
}

const getData = () => {
  const api = $url.settings.getBankAccount
  $api(api, { uriParams: { ID: id.value } }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      formData.value.accountName = resData.data.accountName || ''
      formData.value.bankName = resData.data.bankName || ''
      formData.value.branch = resData.data.branch || ''
      formData.value.swiftCode = resData.data.swiftCode || ''
      formData.value.bankAddress = resData.data.bankAddress || ''
      formData.value.accountNumber = resData.data.accountNumber || ''
      visible.value = true
    }
  })
}

defineExpose({
  open
})
</script>
